// extracted by mini-css-extract-plugin
export default {"timer-actions":"TimerActions_timer-actions__d6wpA","timer-actions__button-reset":"TimerActions_timer-actions__button-reset__TOHjU"};